<template>
    <li class="card card--backed-white card--fixed card--year">
        <a :href="event_url" class="" >
            <div class="card__content">
                <div class="media-wrap">
                    <img class="" :alt="event.title" :title="event.title" :src="event.banner_image !== null ? event.banner_image.sizes.thumbnail.url : fallback_thumbnail">
                    <time v-if="event_date_comparison" class="date-block date-block--card">
                        <div class="date-block__month">{{ event_month(event.start) }}</div>
                        <div class="date-block__day">{{ event_day(event.start) }}</div>
                    </time>
                    <div v-else class="date-block date-block--card">
                        <div class="date-block__date-range">{{ event_month(event.start) }} {{ event_day(event.start) }}</div>
                        <div class="date-block__date-range">{{ event_month(event.end) }} {{ event_day(event.end) }}</div>
                    </div>
                </div>  
                <h3 class="card__title">{{ event.title }}</h3>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        event: Array,
        ext_url: Boolean,
        fallback_thumbnail: String
    },
    data() {
        return {
            start_date: null,
            end_date: null
        }
    },
    computed: { 
        shortened_description() {
            var html = this.event.description
            var div = document.createElement('div'); 
            div.innerHTML = html; 
            var description = div.textContent || div.innerText || '';
            if(description.length > 0) {
                return description.substring(0, 80) + '...';
            } else {
                return false
            }
        },
        event_date_comparison() {
            // Lets get out two dates, strip the time values, and compare the dates
            let start = new Date(this.event.start.replace(" ","T"));
            start.setHours(0, 0, 0, 0);
            let start_date = start.toString();
            
            let end = new Date(this.event.end.replace(" ","T")); 
            end.setHours(0, 0, 0, 0);
            let end_date = end.toString();

            // Comapre if different dates
            if(end_date !== start_date){ 
                return false;
            } else {
                return true;
            }
        },
        event_url() {
            // Check if the toggle for using external URLs is set
            if(this.ext_url == true) {
                // If so then see if an external URL value is set
                if(this.event.url.length > 0) {
                    // If so use it
                    return this.event.url;
                } else {
                    // Otherwise use the Events Factory page URL
                    return 'https://www.kent.ac.uk/events/event/'+this.event.id+'/'+this.event.slug;
                }
            } else {
                // Use the Events Factory page URL
                return 'https://www.kent.ac.uk/events/event/'+this.event.id+'/'+this.event.slug;
            }
        }
    },
    methods: {
        event_day(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            return converted_date.getDate();
        },
        event_month(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            var month = converted_date.getMonth()+1;
            const month_names = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return month_names[month];
        },
        event_time(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            let time = converted_date.toISOString().replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1");
            return time;
        }
    },
    created() {
        
    }
}
</script>
